import classes from "./SelectAddUsers.module.scss";
import { useDispatch } from "react-redux";
import CardTouch from "../../../../UI/Card/CardTouch/CardTouch";
import TenUsers from "./../../../../../assets/images/10_users.svg";
import ThirtyUsers from "./../../../../../assets/images/30_users.svg";
import { useTranslation } from "react-i18next";
import SystemContext from "../../../../../context/SystemContext";
import { useContext } from "react";

const SelectAddUsers = ({ session, Products }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const { changePropertyUrl } = useContext(SystemContext);
  
  const PriceMonthlyUsers = (id) => {
    const PlanValue = Products.periodicity.filter(
      (item) => item.id === id && item.periodicity === "monthly"
    );
    return PlanValue[0]?.price?.toLocaleString("pt-br", {
      style: "currency",
      currency: "BRL",
    });
  };

  const SelectAddUsers = (users) => {
    changePropertyUrl("/comprar/turbinar/usuarios/"+users.toLocaleString())

    dispatch({
      type: "PURCHASE",
      purchase: {
        content: "ChooseAdd",
        step: "MyAddPurchase",
      },
      PostData: {
        sub: session.sub,
        product_id: users === 10 ? [6] : [5],
        email: session.email,
      },
      planInfo: {
        value: users === 10 ? PriceMonthlyUsers(6) : PriceMonthlyUsers(5),
      },
    });
  };

  return (
    <div className={classes.Card}>
      <CardTouch
        data-testid="boostSubscription_addTenUsers_btn"
        onClick={() => SelectAddUsers(10)}
        classPrimary={classes.CardAddUser}
      >
        <img className={classes.Image} src={TenUsers} alt="" />
        <div className={classes.Package}>{ t("purchase.pack_ten_users")}</div>
        <div className={classes.AddPrice}>{`${PriceMonthlyUsers(
          6
        )} / mês`}</div>
        <div className={classes.Top}>{ t("purchase.add")}</div>
      </CardTouch>
      <CardTouch
        data-testid="boostSubscription_addThirtyUsers_btn"
        onClick={() =>
          session?.permissions?.users_pecks?.["+30"] !== 1 && SelectAddUsers(30)
        }
        classPrimary={classes.CardAddLang}
      >
        <img className={classes.Image} src={ThirtyUsers} alt="" />
        <div className={classes.Package}>{ t("purchase.pack_thirty_users")}</div>
        <div className={classes.AddPrice}>{`${PriceMonthlyUsers(
          5
        )} / mês`}</div>
        {session?.permissions?.users_pecks?.["+30"] === 1 ? (
          <div data-testid="boostSubscription_youAlreadyOwnTheItem_text" className={classes.BtnHasPlan}>{ t("purchase.you_already_own_the_item")}</div>
        ) : (
          <div className={classes.Top}>{ t("purchase.add")}</div>
        )}
      </CardTouch>
    </div>
  );
};

export default SelectAddUsers;
